import { InputIcon as GSBInputIcon } from '@gluestack-ui/themed';

import Icon from 'react-native-vector-icons/FontAwesome6';

import { IInputIcon } from './types';

export const InputIcon = ({ name, ...rest }: IInputIcon) => {
  return (
    <GSBInputIcon
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      as={(props: any) => <Icon name={name} {...props} />}
      {...rest}
    />
  );
};
